export default __webpack_public_path__ + "static/media/features6.991af0f8.jpg";